import { mutatorAction } from 'satcheljs';
import { type MailboxInfo, getAccountKeyForMailboxInfo } from 'owa-client-types';
import { getStore } from '../store/store';
import type { AsyncItemRegistry } from '../store/schema/AsyncItemRegistry';
import type { AsyncItemEntry } from '../store/schema/AsyncItemEntry';

/**
 * Ensures a registry exists for the account, creating an empty one if absent (idempotent no-op if
 * it already exists). Sole creator of the per-account registry.
 */
export const ensureAsyncItemRegistryMutator: (mailboxInfo: MailboxInfo) => void = mutatorAction(
    'ensureAsyncItemRegistryMutator',
    mailboxInfo => {
        const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
        const store = getStore();
        if (!store.registryByAccount.has(accountKey)) {
            const registry: AsyncItemRegistry = {
                entriesById: new Map<string, AsyncItemEntry>(),
                seedStatus: 'notSeeded',
            };
            store.registryByAccount.set(accountKey, registry);
        }
    }
);
